'use client';

import Image from 'next/image';
import { useState } from 'react';

export default function ContactCx({ block }) {
  const { faq, hours_text, icon, title_link_text, title_text } =
    block.contact_cx;
  const [activeIndex, setActiveIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  function openChat() {
    const widgetFrame = document?.querySelector('iframe[src*="kodif"]');
    if (widgetFrame && widgetFrame?.contentWindow) {
      widgetFrame.contentWindow.postMessage(
        { type: 'toggle-expanded', isExpanded: true },
        '*'
      );
    }
  }

  function toggleFaqAccordion(index) {
    if (activeIndex === index) {
      setActiveIndex(null);
      setIsOpen(!isOpen);
    } else {
      setActiveIndex(index);
      setIsOpen(true);
    }
  }

  return (
    <div id="contact-cx-section" className={`mt-4 bg-white px-4 py-5 lg:px-6`}>
      <div id="contact-cx-header">
        <div className="button-s flex justify-center">
          {icon?.url && (
            <Image
              src={icon.url}
              width="24"
              height="24"
              sizes="24px"
              alt={icon.title.replace(/\.[^/.]+$/, '')}
            />
          )}
          <div className="pr-2 pl-1">{title_text}</div>
          <button
            className="cursor-pointer underline"
            onClick={openChat}
            type="button"
          >
            {title_link_text}
          </button>
        </div>
        <div className="body-s text-parlor-green-80 pt-2 text-center">
          {hours_text}
        </div>
      </div>
      {faq?.length > 0 && (
        <div id="contact-cx-faq" className="pt-5">
          {faq.map((item, index) => {
            return (
              <div
                className={`group border-dawn-grey-60 w-full border-b text-left focus:outline-none ${index == 0 ? 'border-t' : ''}`}
                key={index}
                tabIndex="0"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
              >
                <div className="group relative flex cursor-pointer items-center justify-between py-3 transition">
                  <div
                    className="flex w-full justify-between"
                    onClick={() => toggleFaqAccordion(index)}
                  >
                    <span className="grow pr-4 pl-2">
                      <h3
                        className="body-s group-hover:text-cozy-cognac transition"
                        role="heading"
                        aria-level="2"
                        itemProp="name"
                      >
                        {item.title}
                      </h3>
                    </span>
                    <span
                      className={`group-hover:bg-cozy-cognac toggle-open mr-2 flex-none text-right ${activeIndex === index ? 'toggle-close' : ''}`}
                    ></span>
                  </div>
                </div>
                <div
                  className={`${activeIndex === index ? 'max-h-screen' : 'max-h-0'} overflow-hidden ${isOpen && activeIndex === index ? 'duration-600 ease-in' : 'duration-300 ease-out'}`}
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.body_text
                    }}
                    className="body-s rte block px-2 pb-4"
                    itemProp="text"
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
